/*****
 * Created with WebStorm.
 * Date : 2019/5/31.
 * Author : Ztr.
 * Func : ....
 * note : 患者端
 ******/
import $https from '@/utils/https'


//登录接口
export function login (params) {
    return $https({
        url: '/api/doctor/account/login',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}


export function login2 (params) {
  return $https({
    url: '/api/account/login',
    method: 'POST',
    // serviceId: 'api.login',
    param: params
  })
}

//测试
export function getDemoList (params) {
  return $https({
    url: '/api/user/list',
    method: 'GET',
    serviceId: 'api.getList',
    param: params
  })
}
//获取微信接口权限配置
export function getWxConfig (params) {
  return $https({
    url: '/api/wechat/wechatJsapiConfig',
    method: 'POST',
    serviceId: '',
    param: params
  })
}
//发送语音
export function sendMyVoice (params) {
  return $https({
    url: '/api/voice/sendVoice',
    method: 'POST',
    serviceId: '',
    param: params
  })
}
//发送语音(后端直接推送云信)
export function getMyVoice (params) {
  return $https({
    url: '/api/voice/getVoice',
    method: 'POST',
    serviceId: '',
    param: params
  })
}
//获取未读消息
export function getNoReadMess (params, loadingTxt) {
  return $https({
    url: '/api/cms/msg/getUnreadMsgCount',
    method: 'POST',
    serviceId: '',
    param: params,
    loadingTxt
  })
}

//患者加密数据同步接口
export function encryptedLogin (params) {
  return $https({
    url: '/api/account/encryptedLogin',
    method: 'POST',
    serviceId: '',
    param: params
  })
}



// WEBPACK FOOTER //
// ./src/services/modules/user.js